import angular from 'angular';
import tableGridValidationCellComponent from './tableGridValidationCell.component';

let tableGridValidationCellModule = angular.module('tableGridValidationCell', []).directive('tableGridValidationCell', tableGridValidationCellComponent);

export default tableGridValidationCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridValidationCell/tableGridValidationCell.js